import React from "react";

export default function AppFooter({
  version = "v0.1.4",
  leftText = "MAD Discovery — MAD ABOUT DIGITAL.",
  rightText = null,
}) {
  return (
    <footer
      className="page-footer"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <small>{leftText}</small>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {rightText ? <small>{rightText}</small> : null}
        <small>Build {version}</small>
      </div>
    </footer>
  );
}
